module.exports = __webpack_public_path__ + "img/appBrand--ax-full-dark.79fd9895.svg";